const SIGNUP_INTENT_KEY = 'dms-ark:signup-intent';
const SIGNUP_INTENT_MAX_AGE_MS = 24 * 60 * 60 * 1000;
const TRIAL_SIGNUP_DESTINATION = 'AW-826196229/eHR-CKiivq4dEIWC-4kD';

/**
 * Keep an explicit signup intent through the Auth0 redirect. We do not infer
 * a conversion from every authenticated visit, since existing users log in
 * through the same callback route.
 */
export const markSignupIntent = () => {
  try {
    window.localStorage.setItem(SIGNUP_INTENT_KEY, String(Date.now()));
  } catch {
    // Conversion measurement must never interfere with authentication.
  }
};

const hasPendingSignupIntent = () => {
  try {
    const recordedAt = Number(window.localStorage.getItem(SIGNUP_INTENT_KEY));
    const age = Date.now() - recordedAt;
    return Number.isFinite(recordedAt) && age >= 0 && age <= SIGNUP_INTENT_MAX_AGE_MS;
  } catch {
    return false;
  }
};

const clearSignupIntent = () => {
  try {
    window.localStorage.removeItem(SIGNUP_INTENT_KEY);
  } catch {
    // Best-effort cleanup only.
  }
};

/**
 * Report one completed free-trial signup per browser account. Google Ads only
 * attributes the event when the visitor has a valid ad click identifier.
 */
export const trackGoogleAdsTrialSignup = (userId: string) => {
  if (!hasPendingSignupIntent()) return;

  const conversionKey = `dms-ark:google-ads-trial-signup:${userId}`;
  try {
    if (window.localStorage.getItem(conversionKey)) {
      clearSignupIntent();
      return;
    }

    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'conversion', {
      send_to: TRIAL_SIGNUP_DESTINATION,
      value: 1,
      currency: 'USD'
    });
    window.localStorage.setItem(conversionKey, '1');
    clearSignupIntent();
  } catch {
    // Do not block the first-run experience if storage or the tag is blocked.
  }
};
